import axios from '../utils/axios'

export function getStateApi(params) {
  return axios.post('/settle/apiSettleAwService/marketingRuleDetail', params)
}
